import { ILeadModalDetail, leadModalManager } from '@vfit/shared/data-access';

export const openLeadModal = (props: ILeadModalDetail) => {
  leadModalManager.handleLeadModal({ ...props });
};
